import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { Classes } from '../../../base/styles';
import FilterPanel from './FilterPanel';
import DefaultFilterContent from './DefaultFilterContent';
import { calculatePopupRelative } from '../../../utils';
var HEADER_ICON_OFFSET_Y = 6 + 1; //padding-top + border

var HEADER_ICON_OFFSET_X = 16 + 1; //padding-left+ border

var FilterIconSpanStyle = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 4px;\n  cursor: pointer;\n  transform: translateY(-50%);\n  top: 50%;\n  height: 12px; \n"])));

function Filter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 12 : _ref$size,
      style = _ref.style,
      className = _ref.className,
      FilterPanelContent = _ref.FilterPanelContent,
      filterIcon = _ref.filterIcon,
      setFilter = _ref.setFilter,
      setFilterModel = _ref.setFilterModel,
      filterModel = _ref.filterModel,
      isFilterActive = _ref.isFilterActive,
      stopClickEventPropagation = _ref.stopClickEventPropagation;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPanel = _React$useState2[0],
      setShowPanel = _React$useState2[1];

  var iconRef = React.useRef(null);

  var hidePanel = function hidePanel() {
    return setShowPanel(false);
  };

  var handleMouseDown = function handleMouseDown(e) {
    e.stopPropagation(); // 阻止触发拖拽
  };

  var renderPanelContent = function renderPanelContent() {
    if (FilterPanelContent) {
      return /*#__PURE__*/React.createElement(FilterPanelContent, {
        setFilter: setFilter,
        filterModel: filterModel,
        isFilterActive: isFilterActive,
        hidePanel: hidePanel
      });
    } else {
      return /*#__PURE__*/React.createElement(DefaultFilterContent, {
        setFilterModel: setFilterModel,
        filterModel: filterModel,
        isFilterActive: isFilterActive,
        hidePanel: hidePanel
      });
    }
  };

  var renderPanel = function renderPanel(ele) {
    var position = calculatePopupRelative(ele, document.body, {
      x: HEADER_ICON_OFFSET_X,
      y: HEADER_ICON_OFFSET_Y
    });
    var style = {
      position: 'absolute',
      zIndex: 1050
    };
    return /*#__PURE__*/React.createElement(FilterPanel, {
      style: style,
      onClose: hidePanel,
      position: position,
      filterIcon: filterIcon
    }, renderPanelContent());
  };

  var handleIconClick = function handleIconClick(e) {
    if (stopClickEventPropagation) {
      e.stopPropagation();
    }

    setShowPanel(true);
  };

  return /*#__PURE__*/React.createElement(FilterIconSpanStyle, {
    style: style,
    className: className,
    onMouseDown: handleMouseDown,
    ref: iconRef
  }, /*#__PURE__*/React.createElement("span", {
    className: Classes.filterIcon,
    onClick: handleIconClick
  }, filterIcon || /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "filter",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3\n              31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5\n              48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
  }))), showPanel && /*#__PURE__*/createPortal(renderPanel(iconRef.current), document.body));
}

export default Filter;